module.exports = __webpack_public_path__ + "img/warrior.88753986.jpg";